import type {NamedSetState} from 'app/gemStore/devtools';

import type {LazyLoadPageSlice} from './types';

const initialLazyLoadPage = process?.env?.NODE_ENV !== 'test';

export const createLazyLoadPageSlice = (set: NamedSetState<LazyLoadPageSlice>) => ({
    lazyLoadPage: initialLazyLoadPage,
    setLazyLoadPage: (lazyLoadPage: boolean) => set({lazyLoadPage}, false, 'lazyLoadPage/setLazyLoadPage'),
});
